import type { PageLoad } from './$types';
import { getLocale, i18nPath } from '$lib/i18n/routing';
import { routesPagename } from '$lib/services/urls/routesPagename';
import { redirect } from '@sveltejs/kit';
import { getLanguageFromLocale } from '@viamichelin/business';
import { getPoisWithinRadiusStore } from '../loadPoisFromZoi';

export const load = (async (event) => {
	const { searchParams } = await event.parent();
	const { page, zoi } = searchParams;

	if (!zoi) {
		redirect(302, i18nPath(`/routes${event.url.search}`, getLanguageFromLocale(getLocale(event.url))));
	}

	const poisStore = await getPoisWithinRadiusStore({
		event,
		page,
		searchParams,
		center: zoi.center,
		radius: zoi.radius * 1000,
	});

	return {
		page,
		poisStore,
		mobileTopButtons: ['search'],
		pagename: routesPagename.POI_FILTER,
		isTopLevelPage: false,
	};
}) satisfies PageLoad;
